import { create } from 'zustand';

interface SyncState {
  syncing: boolean;
  pending: number;
  conflicts: number;
  lastSyncedAt: string | null;
  setSyncing: (b: boolean) => void;
  bumpPending: () => void;
  setPending: (n: number) => void;
  setConflicts: (n: number) => void;
  setLastSyncedAt: (s: string) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  syncing: false,
  pending: 0,
  conflicts: 0,
  lastSyncedAt: null,
  setSyncing: (b) => set({ syncing: b }),
  bumpPending: () => set((s) => ({ pending: s.pending + 1 })),
  setPending: (n) => set({ pending: n }),
  setConflicts: (n) => set({ conflicts: n }),
  setLastSyncedAt: (s) => set({ lastSyncedAt: s }),
}));
